module.exports = new __parcel__URL__("faded-words.84c5d2ae.mp4").toString();